import { Controller } from "@hotwired/stimulus"

// La tabella dello stato per voce di Erogazione.js (31a5bd1): la riga di una voce con motivi si apre sulla riga dei suoi
// motivi (ChevronUp) e si richiude con un altro clic; una sola voce aperta alla volta (`aperta` è un id solo). Le
// righe senza motivi non fanno nulla. Il server rende tutte le righe dei motivi `hidden`.
//   <table data-controller="righe-espandibili"> <tr data-righe-espandibili-target="riga" data-righe-espandibili-id-value="v1"
//     data-action="click->righe-espandibili#alterna"> … <tr data-righe-espandibili-target="motivi" data-righe-espandibili-id-value="v1" hidden>
export default class extends Controller {
  static targets = ["riga", "motivi"]

  alterna(event) {
    const riga = event.currentTarget
    if (!riga.hasAttribute("aria-expanded")) return
    const id = riga.dataset.righeEspandibiliIdValue
    const apri = riga.getAttribute("aria-expanded") !== "true"
    this.rigaTargets.forEach((r) => this.#mostra(r, apri && r.dataset.righeEspandibiliIdValue === id))
  }

  #mostra(riga, aperta) {
    if (!riga.hasAttribute("aria-expanded")) return
    riga.setAttribute("aria-expanded", String(aperta))
    riga.querySelector("[data-righe-espandibili-target='giu']")?.classList.toggle("hidden", aperta)
    riga.querySelector("[data-righe-espandibili-target='su']")?.classList.toggle("hidden", !aperta)
    const id = riga.dataset.righeEspandibiliIdValue
    this.motiviTargets.forEach((m) => { if (m.dataset.righeEspandibiliIdValue === id) m.hidden = !aperta })
  }
}
